/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'

import {
  TextBody,
  TextHeading,
  useModal,
  Box,
  Modal,
  Button,
  Space,
} from '@ally/metronome-ui'

const Trigger: React.FC = () => {
  const { showModal } = useModal()
  return (
    <Box>
      <Button variant="link" text="Supported carriers" onClick={showModal} />
    </Box>
  )
}

const headingRef = React.createRef<HTMLHeadingElement>()

const Content: React.FC = () => (
  <Box mb="md">
    <Space mb="md">
      <TextHeading tag="h1" size="lg" tabIndex={-1} ref={headingRef}>
        Supported Carriers
      </TextHeading>
    </Space>
    <TextBody size="sm" tag="p">
      We support AT&amp;T, Boost Mobile, Claro, Cricket, C-Spire USA, Open
      Mobile, T-Mobile&reg; and Metro by T-Mobile&reg;, Sprint, U.S. Cellular
      USA, Verizon Wireless USA, Virgin Mobile, and providers who operate on
      Interop and ClearSky technologies. We don&apos;t support Voice over
      Internet Protocol numbers (such as Google Voice&trade;) for SMS alerts or
      multi-factor authentication.
    </TextBody>
  </Box>
)

export const SupportedCarriersModal: React.FC = () => {
  return <Modal content={<Content />} ref={headingRef} trigger={<Trigger />} />
}
